import type { FC } from "react";

type AuthPageTitleProps = {
  title: string;
  subTitle: string;
  param?: string;
};

const AuthPageTitle: FC<AuthPageTitleProps> = ({ title, subTitle, param }) => {
  return (
    <div className="flex flex-col gap-[12px] w-full items-center">
      <h1 className="text-5xl font-medium text-center">{title}</h1>
      <p className="text-center text-gray-600">
        {subTitle}
        {param ? <span className="font-semibold">{param}</span> : null}
      </p>
    </div>
  );
};

export default AuthPageTitle;
